import { createLazyFileRoute } from "@tanstack/react-router";
import { memo } from "react";

import { Dashboard } from "@/features/dashboard";

export const Route = createLazyFileRoute("/_auth/_app/")({
  component: memo(Dashboard),
});
